import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

// ON/OFF for one strategy; both strategies are independent and optional
export function StrategySwitch({ id, label, onChange }) {
  const [on, setOn] = useState(null);
  useEffect(() => { api.get("/strategies").then((r) => { setOn(r.data[id]); onChange?.(r.data[id]); }).catch(() => {}); }, [id]); // eslint-disable-line react-hooks/exhaustive-deps
  const flip = async () => {
    try {
      const r = await api.put("/strategies", { [id]: !on });
      setOn(r.data[id]); onChange?.(r.data[id]);
      toast.success(`${label} ${r.data[id] ? "ON" : "OFF"}`);
    } catch (e) { toast.error(errMsg(e)); }
  };
  if (on === null) return null;
  return (
    <button onClick={flip} data-testid={`strategy-switch-${id}`} aria-pressed={on}
      className={`w-full flex items-center justify-between px-3 h-10 rounded-md border text-xs font-semibold transition-colors ${on ? "border-cyan-500/50 bg-cyan-500/10 text-cyan-300" : "border-slate-600 bg-[#0B111D] text-slate-400"}`}>
      <span>{label}</span>
      <span className="flex items-center gap-2">{on ? "ON" : "OFF"}
        <span className={`w-8 h-4 rounded-full relative ${on ? "bg-cyan-500" : "bg-slate-600"}`}>
          <span className={`absolute top-0.5 w-3 h-3 rounded-full bg-white transition-transform ${on ? "translate-x-4" : "translate-x-0.5"}`} />
        </span>
      </span>
    </button>
  );
}
